import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  margin: ", " 0 0; /* negative margin to overlap with illustration bubble */\n  z-index: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: ", " auto ", ";\n  padding: ", " ", " ", ";\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Icon, Image } from '@scp/ui-shared/theme/icons';
import { LinkOrButton } from '@scp/ui-shared/components/buttons';
import { Paper } from '@scp/ui-shared/components';
import { Paragraph, Heading2 } from '@scp/ui-shared/components/typography';
import { color, typography } from '@scp/ui-shared/theme/variables';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { Spacing } from './Spacing';
var devicesIconSize = 250;
var TEXT = {
  TITLE: 'Looking for a specific feature?',
  MESSAGE: 'Please reach out to mySCP support if you have questions!',
  HELP_TITLE: 'Need help?',
  CALL_US: "Call us at",
  EMAIL_US_AT: 'Email us at'
};
var Container = styled(Paper)(_templateObject(), baselineToRem(10), baselineToRem(5), baselineToRem(13), baselineToRem(10), baselineToRem(7), baselineToRem(196));
var Title = styled(Heading2)(_templateObject2(), typography.fontWeightSemiBold, baselineToRem(-6));
var ContactMessageWrapper = styled.div(_templateObject3());
var StyledLink = styled(LinkOrButton)(_templateObject4(), baselineToRem(1));

var renderDevicesIcon = function renderDevicesIcon(url) {
  return url ? React.createElement(Image, {
    width: devicesIconSize,
    height: devicesIconSize,
    url: url
  }) : React.createElement(Icon, {
    name: "devices",
    size: devicesIconSize,
    color: color.icon
  });
};

export var EmptyPage = function EmptyPage(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? TEXT.TITLE : _ref$title,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? TEXT.MESSAGE : _ref$message,
      email = _ref.email,
      phone = _ref.phone,
      iconUrl = _ref.iconUrl;
  return React.createElement(Container, null, renderDevicesIcon(iconUrl), React.createElement(Title, null, title), React.createElement(Paragraph, {
    secondary: true
  }, message), !!(phone || email) && React.createElement(Spacing, {
    marginTop: 24
  }, React.createElement(ContactMessageWrapper, null, React.createElement(Paragraph, {
    bold: true,
    secondary: true
  }, TEXT.HELP_TITLE)), !!phone && React.createElement(ContactMessageWrapper, null, React.createElement(Paragraph, {
    secondary: true,
    noMargin: true
  }, TEXT.CALL_US, " ", phone)), !!email && React.createElement(ContactMessageWrapper, null, React.createElement(Paragraph, {
    secondary: true
  }, TEXT.EMAIL_US_AT), React.createElement(StyledLink, {
    href: "mailto:".concat(email)
  }, email))));
};